<template>
  <div class="content-ct">
    <el-row>
      <el-col :xs="9" :sm="9" :md="8" :lg="6">
        <game-campaign-content-nav
          :menu-items="setupNavigation"
          :default-active="activeItemTitle"
          @update="setActiveItem"
        />
      </el-col>
      <el-col :xs="15" :sm="15" :md="16" :lg="18">
        <component
          v-if="activeItem"
          :is="activeItem.component"
          :is-completed="activeItem.isCompleted"
          :is-bracket-predictor-game="isBracketPredictorGame"
          :is-read-only="isReadOnly"
          :is-creation-mode="isCreationMode"
          :save-flag="saveFlag"
          :game-campaign-id="gameCampaignId"
          :game="game"
          :campaign="campaign"
          :has-saved-bracket="hasSavedBracket"
          @goToNextStep="goToNextStep"
          @check="$emit('check', $event)"
          @checkChanges="checkChanges"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { customConfirm } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
import GameCampaignContentNav from '@/modules/gamification/components/games-campaigns/GameCampaignContentNav.vue'
import GameBasicSetupForm from '@/modules/gamification/components/games-campaigns/setup/common/GameBasicSetupForm.vue'
import BracketBuilderForm from '@/modules/gamification/components/games-campaigns/setup/common/BracketBuilderForm.vue'
import GameCompetitionTeamsForm from '@/modules/gamification/components/games-campaigns/setup/bracketPredictor/GameCompetitionTeamsForm.vue'
import { GameCreationSubSteps } from '@/modules/gamification/enum/GameCreationStepsEnum.js'
import { updateNavigationState } from '@/modules/gamification/helpers'

export default {
  name: 'GameStepSetup',

  components: {
    GameCampaignContentNav,
    GameBasicSetupForm,
    GameCompetitionTeamsForm,
    BracketBuilderForm
  },

  props: {
    isBracketPredictorGame: {
      type: Boolean,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isCreationMode: {
      type: Boolean,
      required: true
    },
    completedSubSteps: {
      type: Array,
      required: true
    },
    currentSubStep: {
      type: String,
      default: GameCreationSubSteps.BASIC_SET_UP
    },
    saveFlag: {
      type: Boolean,
      required: true
    },
    gameCampaignId: {
      type: Number
    },
    game: {
      type: Object,
      required: true
    },
    isManualBracket: {
      type: Boolean,
      default: false
    },
    hasSavedBracket: {
      type: Boolean,
      default: false
    },
    campaign: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      activeItem: null,
      navigation: [
        {
          title: this.$t('Gamification_GameStepSetup_BasicSetup'),
          step: GameCreationSubSteps.BASIC_SET_UP,
          component: GameBasicSetupForm,
          isCompleted: false,
          disabled: false
        },
        {
          title: this.$t('Gamification_GameStepSetup_CompetitionTeam'),
          step: GameCreationSubSteps.COMPETITION_TEAMS,
          component: GameCompetitionTeamsForm,
          isCompleted: false,
          disabled: false
        },
        {
          title: this.$t('Gamification_BracketBuilder'),
          step: GameCreationSubSteps.BRACKET_BUILDER,
          component: BracketBuilderForm,
          isCompleted: false,
          disabled: false
        }
      ],
      hasChanges: false
    }
  },

  computed: {
    setupNavigation() {
      let navigation = [...this.navigation]

      if (!this.isBracketPredictorGame) {
        navigation = navigation.filter(
          item => item.step !== GameCreationSubSteps.COMPETITION_TEAMS
        )
      }

      if (!this.isManualBracket) {
        navigation = navigation.filter(
          item => item.step !== GameCreationSubSteps.BRACKET_BUILDER
        )
      }

      return navigation
    },
    activeItemTitle() {
      return this.activeItem ? this.activeItem.title : null
    }
  },
  mounted() {
    this.updateNavigation()
  },
  watch: {
    currentSubStep() {
      this.updateNavigation()
    }
  },
  methods: {
    setActiveItem(tab) {
      if (!this.hasChanges) {
        this.activeItem = tab
        return
      }

      customConfirm(
        this.$t('Gamification_LeavingWithoutSaving'),
        this.$t('Gamification_LeavingWithoutSavingDescription'),
        this.$t('Gamification_Confirm_Button_Leave')
      ).then(() => {
        this.activeItem = tab
      })
    },
    updateNavigation() {
      this.activeItem =
        this.setupNavigation.find(item => item.step === this.currentSubStep) ||
        this.setupNavigation[0]

      if (this.isCreationMode) {
        updateNavigationState(
          this.navigation,
          this.completedSubSteps,
          this.currentSubStep,
          this.hasSavedBracket
        )
      }
    },
    goToNextStep(step) {
      const stepIndex = this.setupNavigation.findIndex(
        item => item.step === step
      )
      const isLastStep = stepIndex + 1 === this.setupNavigation.length
      if (stepIndex !== -1 && isLastStep) {
        EventBus.$emit('campaign-create-next-step')
      }

      EventBus.$emit('updateStep', step)
    },
    checkChanges(payload) {
      this.hasChanges = payload
      this.$emit('checkChanges', payload)
    }
  }
}
</script>

<style scoped>
.content-ct {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GameStepSetup.vue